<h2 mat-dialog-title>{{ data.title }}</h2>
<mat-dialog-content class="mat-typography">
	<p>{{ data.message }}</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
	<button mat-raised-button mat-dialog-close>Cancel</button>
	<button mat-raised-button color="primary" [mat-dialog-close]="true" cdkFocusInitial>Ok</button>
</mat-dialog-actions>
